export default __webpack_public_path__ + "dd35a85390537532edec29975cf63007.png";